import React, { Component } from 'react';
import clorianLogo from '../../resources/images/clorian-logotipo.png';
import { NavLink } from 'react-router-dom';
import { Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import history from '../../history';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

class Header extends Component {
  render() {
    const verifier = JSON.parse(sessionStorage.getItem('verifier'));
    const logout = () => {
      sessionStorage.clear();
      history.push('/');
    };

    const goTo = page => {
      if (page === '/validatorSelection') {
        const storage = [
          'accesses',
          'buyertypes',
          'currentConfiguration',
          'events',
          'extras',
          'promotions',
          'venuecapacities',
          'verifier'
        ];
        storage.map(item => sessionStorage.removeItem(item));
      }
      history.push(page);
    };

    return (
      <header>
        <div className="header">
          <div className="header-brand">
            <img src={clorianLogo} alt="logo" />
          </div>

          <div className="header-title">
            <h1 className="title">
              <FormattedMessage
                id="validator.header"
                defaultMessage="Validador Web"
              />
            </h1>

            <div className="actions hidden-xs">
              <DropdownButton title={verifier.name} id={`dropdown-basic`}>
                <MenuItem eventKey="1" onClick={() => goTo('/configuration')}>
                  <span className="glyphicon glyphicon-cog" /> <FormattedMessage defaultMessage="Settings" id="menu.settings"/>
                </MenuItem>
                <MenuItem
                  eventKey="2"
                  onClick={() => goTo('/validatorSelection')}
                >
                  <span className="glyphicon glyphicon-log-out" /> <FormattedMessage defaultMessage="Change validator" id="menu.change.validator"/>
                </MenuItem>
                <MenuItem divider />
                <MenuItem eventKey="3" onClick={logout}>
                  <span className="glyphicon glyphicon-log-out" /> <FormattedMessage defaultMessage="Logout" id="menu.logout"/>
                </MenuItem>
              </DropdownButton>
            </div>

            <div className="actions visible-xs">
              <Dropdown id={`dropdown-custom-1`}>
                <Dropdown.Toggle noCaret>
                  <span className="glyphicon glyphicon-option-vertical" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem eventKey="1" onClick={() => goTo('/configuration')}>
                    <span className="glyphicon glyphicon-cog" /> <FormattedMessage defaultMessage="Settings" id="menu.settings"/>
                  </MenuItem>
                  <MenuItem
                    eventKey="2"
                    onClick={() => goTo('/validatorSelection')}
                  >
                    <span className="glyphicon glyphicon-log-out" /> <FormattedMessage defaultMessage="Change validator" id="menu.change.validator"/>
                    validator
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem eventKey="3" onClick={logout}>
                    <span className="glyphicon glyphicon-log-out" /> <FormattedMessage defaultMessage="Logout" id="menu.logout"/>
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div className="container navigation">
          <ul className="nav nav-pills">
            <li role="presentation">
              <NavLink to="/validator" activeClassName="active">
                <span className="glyphicon glyphicon-qrcode" /> <FormattedMessage defaultMessage="Validar" id="menu.validate"/>
              </NavLink>
            </li>
            {/*<li role="presentation"><NavLink to="/ticket-info" activeClassName="active"><span className="glyphicon glyphicon-search"></span> Buscar</NavLink></li>*/}
            <li role="presentation">
              <NavLink to="/reports" activeClassName="active">
                <span className="glyphicon glyphicon-stats" /> <FormattedMessage defaultMessage="Informes" id="menu.report"/>
              </NavLink>
            </li>
            <li role="presentation">
              <NavLink to="/display" activeClassName="active">
                <span className="glyphicon glyphicon-new-window" /> <FormattedMessage defaultMessage="Display" id="menu.display"/>
              </NavLink>
            </li>
          </ul>
        </div>
      </header>
    );
  }
}

export default connect()(Header);
